import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INDUSTRIES } from "@/lib/coal-data";

export default function Industries() {
    return (
        <div data-testid="page-industries">
            <section className="relative pt-40 pb-20 bg-coal-900 border-b border-white/10 overflow-hidden">
                <div className="absolute right-0 top-0 w-1/2 h-full opacity-50">
                    <img
                        src="https://images.unsplash.com/photo-1761414500570-0b835cdcf3c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxzdGVlbCUyMG1pbGwlMjBpbmR1c3RyaWFsJTIwcGxhbnR8ZW58MHx8fHwxNzc4Njg3OTczfDA&ixlib=rb-4.1.0&q=85"
                        alt="Steel plant"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-coal-900 via-coal-900/85 to-transparent" />
                </div>
                <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
                    <div className="text-xs tracking-[0.25em] uppercase text-ember font-bold mb-6">
                        Industries Served
                    </div>
                    <h1 className="font-display font-bold text-5xl sm:text-7xl uppercase tracking-tighter leading-[0.92] text-white max-w-4xl">
                        Where India
                        <br />
                        runs on coal.
                    </h1>
                    <p className="mt-8 max-w-2xl text-lg text-zinc-300 leading-relaxed">
                        From integrated steel plants to small-batch FBC
                        boilers, we ship calibrated fuel for the country's
                        most demanding industrial workloads.
                    </p>
                </div>
            </section>

            <section className="section bg-coal-900">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {INDUSTRIES.map((ind, i) => (
                        <div
                            key={ind.name}
                            data-testid={`industry-${i}`}
                            className="bg-coal-800 p-8 lg:p-10 hover:bg-coal-700 transition-colors"
                        >
                            <div className="flex items-baseline justify-between mb-6">
                                <div className="text-[10px] tracking-[0.25em] uppercase text-ember font-bold">
                                    {ind.kicker}
                                </div>
                                <div className="font-mono text-zinc-600 text-xs">
                                    /{String(i + 1).padStart(2, "0")}
                                </div>
                            </div>
                            <h3 className="font-display text-3xl font-bold text-white mb-4 leading-tight">
                                {ind.name}
                            </h3>
                            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                                {ind.description}
                            </p>
                            <div className="pt-6 border-t border-white/5">
                                <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-3">
                                    Typical Grades
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    {ind.coalTypes.map((c) => (
                                        <span
                                            key={c}
                                            className="text-xs text-zinc-200 border border-white/10 px-3 py-1 font-mono"
                                        >
                                            {c}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="section bg-coal-800 border-t border-white/10">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <h2 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white leading-[1]">
                        Don't see your industry?
                        <br />
                        We've shipped to it.
                    </h2>
                    <Link
                        to="/contact"
                        className="group bg-ember hover:bg-ember-hover text-white px-8 py-5 font-bold tracking-[0.18em] uppercase text-sm transition-colors flex items-center gap-3 self-start lg:self-auto"
                    >
                        Discuss your spec
                        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                </div>
            </section>
        </div>
    );
}
